import { oosCanadaProductIds, oosUkProductIds, oosUsaProductIds } from "./geolocation-handler.js";

class BartesianPricingUI extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.initializeProperties();
    this.removeLoaderElements();
    this.shadowRoot.append(this.createStyles(), this.createStructure());
    this.setupEventListeners();
    this.checkAvailability();
    this.checkOutOfStock();
  }

  initializeProperties() {
    this.sideCart = document.querySelector("side-cart");
    this.uiType = this.getAttribute("ui-type");
    this.variantId = this.getAttribute("variant-id");
    this.productId = this.getAttribute("product-id");
    this.price = JSON.parse(this.getAttribute("price"));
    this.currentTemplate = this.getAttribute("current-template");
    this.oosStates = disableStickyATC[this.productId];
    this.showModifiedPricing = false;
    this.modifiedPricing = this.price?.amount || null;
    this.availability = this.getAttribute("availability");

    if (this.productId === "7697851908295" || this.productId === "7701507276999") {
      // Classic Collection Favorites Variety Pack
      // https://admin.shopify.com/store/bartesianshop/products/7697851908295 (USA & Canada)
      // https://admin.shopify.com/store/bartesianshop/products/7701507276999 (UK)
      this.numCapsulesPerBox = 6;
    } else if (this.productId === "8035822534855" || this.productId === "8773255692487" || this.productId === "7519374901447") {
      // 2024 Advent Calendar
      this.numCapsulesPerBox = 12;
    } else if (this.productId === "8166638452935") {
      // Cocktail Sampler Variety Pack
      this.numCapsulesPerBox = 4;
    } else {
      this.numCapsulesPerBox = 8;
    }
  }

  removeLoaderElements() {
    const loaderElements = document.querySelectorAll(".line-of-dots");
    loaderElements?.forEach((element) => {
      element.classList.remove("line-of-dots");
    });
  }

  setupEventListeners() {
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener("click", this.boundHandleOutsideClick);
  }

  createStyles() {
    const style = document.createElement("style");
    style.textContent = `
      :root {
        --custom-loader-primary: #008fbb;
      }
      .bartesian-pricing-ui-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        position: relative;
      }
      .bartesian-pricing-ui-wrapper-pdp {
        align-items: flex-start;
      }
      .bartesian-pricing-ui-wrapper-plp {
        padding-left: 1rem;
      }
      .bartesian-pricing-ui-inner-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
      }
      .bartesian-pricing-ui-inner-wrapper-pdp {
        flex-direction: column;
        align-items: flex-start;
        margin-top: 1rem;
        width: 100%;
      }
      .add-to-cart-btn:hover {
        cursor: pointer;
      }
      .add-to-cart-btn:disabled {
        cursor: not-allowed;
        ${this.currentTemplate === "product" ? "width: 100%;" : "width: 50px;"}
      }
      .price span,
      .default-price-per-unit span {
        color: rgb(var(--color-foreground));
        font-size: 13px;
        font-family: Encode Sans, sans-serif;
        letter-spacing: 0;
      }
      .price-per-capsule span,
      .price-per-box span {
        font-size: 16px;
        color: #008FBB;
        font-weight: bold;
      }
      .price-font-normal span {
        font-weight: normal;
      }
      .add-to-cart {

      }
      .add-to-cart-pdp {
        width: 100%;
      }
      .add-to-cart-btn {
        display: flex;
        color: white;
        background: #008FBB;
        width: 50px;
        height: 50px;
        justify-content: center;
        align-items: center;
        border: 1px solid #008FBB;
        margin: .5rem 1rem;
        font-size: 1.5rem;
        border-radius: 50%;
        position: relative;
      }
      .add-to-cart-btn .sold-out {
        font-size: 11px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .add-to-cart-btn-pdp {
        background-color: #008FBB;
        font-family: "Encode Sans Condensed", sans-serif;
        font-size: 14px;
        letter-spacing: 2px;
        width: 100%;
        margin: 1rem auto;
        height: 40px;
        border: none;
        border-radius: unset;
      }
      .add-to-cart-btn-pdp .sold-out {
        font-size: 16px;
      }
      .add-to-cart-btn-pdp:hover {
        box-shadow: 0 0 0 0 #008FBB;
        border: unset;
      }
      .add-to-cart-btn-pdp:disabled {
        cursor: not-allowed;
      }
      .quantity-selector {
        display: none;
        position: absolute;
        background: #e0e0e0;
        border: 1px solid #ccc;
        padding: 2rem;
        z-index: 100;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        text-align: center;
        ${this.currentTemplate === "product"
        ? "transform: translate(-50%, -75%);"
        : "transform: translate(-50%, -125%);"
      }
        left: 50%;
        ${this.currentTemplate === "product" ? "" : "top: 50%;"}
        max-height: 260px;
      }
      .quantity-selector h3 {
        font-size: 2rem;
        margin: 0;
      }
      .quantity-selector__container {
        gap: 0.5rem;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
      }
      .predefined-quantity-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        padding: 0;
        gap: 1rem;
        width: 100%;
        margin: 1rem auto 0;
      }
      .predefined-quantity-list__quantity {
        list-style: none;
        margin: 0;
        padding: 0;
      }
      .predefined-quantity-list__quantity-button {
        width: 50px;
        height: 50px;
        background: #fff;
        border: 2px solid #ccc;
        cursor: pointer;
        font-size: 1em;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: background 0.3s, color 0.3s;
      }
      .predefined-quantity-list__quantity-button:hover {
        background: #f0f0f0;
      }
      .predefined-quantity-list__quantity-button.selected {
        background: white;
        color: black;
        border: 2px solid #008FBB;
      }
      .text-field__input {
        width: 110px;
        padding: 10px;
        box-sizing: border-box;
        font-size: 1em;
        border: 2px solid #ccc;
        margin-right: 1rem;
      }
      .text-field__input::placeholder {
        font-size: 1.2rem;
      }
      input.text-field__input[type="number"]::-webkit-outer-spin-button,
      input.text-field__input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input.text-field__input[type="number"]:focus {
        outline: 1px solid #ccc;
        border: 1px solid #ccc;
      }
      .quantity-selector-custom-field__button-ok {
        width: 110px;
        height: 50px;
        background: #008FBB;
        color: #fff;
        border: none;
        cursor: pointer;
        font-size: 14px;
        transition: background 0.3s;
        letter-spacing: 1px;
      }
      .quantity-selector-custom-field__container {
        width: 100%;
        display: flex;
      }
      @media screen and (max-width: 768px) {
        .quantity-selector {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .add-to-cart-btn {
          width: 35px;
          height: 35px;
        }
        .add-to-cart-btn-pdp {
          width: 100%;
        }
        .bartesian-pricing-ui-wrapper-plp .price-per-capsule span {
          font-size: 13px;
        }
        .bartesian-pricing-ui-wrapper-plp .price-per-box span {
          font-size: 13px;
          max-width: 60px !important;
          display: block;
        }
        .bartesian-pricing-ui-wrapper-plp .default-price-per-unit span {
          font-size: 11px;
        }
        .bartesian-pricing-ui-wrapper-plp .add-to-cart {
          margin-right: 0.5rem;
        }
        .add-to-cart-btn .sold-out {
          font-size: 10px;
        }
        .add-to-cart-btn-pdp .sold-out {
          font-size: 14px;
        }
        .add-to-cart-btn:disabled {
          cursor: not-allowed;
          ${this.currentTemplate === "product" ? "width: 100%;" : "width: 35px;"}
        }
      }
    `;
    if (this.classList.contains("holiday-theme")) {
      style.textContent += `
        .add-to-cart {
          display: none !important;
        }
        .price-per-capsule span, .price-per-box span {
          color: black !important;

        }
        .bartesian-pricing-ui-wrapper-plp {
          padding-left: 0 !important;
        }
      `;
    }
    return style;
  }

  createStructure() {
    const wrapper = document.createElement("div");
    wrapper.classList.add("bartesian-pricing-ui-wrapper");

    if (this.currentTemplate === "product") {
      wrapper.classList.add("bartesian-pricing-ui-wrapper-pdp");
    } else {
      wrapper.classList.add("bartesian-pricing-ui-wrapper-plp");
    }

    const innerWrapper = document.createElement("div");
    innerWrapper.classList.add("bartesian-pricing-ui-inner-wrapper");

    if (this.currentTemplate === "product") {
      innerWrapper.classList.add("bartesian-pricing-ui-inner-wrapper-pdp");
      if (this.uiType === "non-variety") {
        innerWrapper.append(
          this.createPriceElement(),
          this.createDefaultPricePerUnitElement(),
          this.createButtonContainer()
        );
      } else {
        innerWrapper.append(this.createPerBoxPriceElement(), this.createButtonContainer());
      }
      wrapper.append(innerWrapper);
    } else {
      if (this.uiType === "non-variety") {
        innerWrapper.append(this.createPriceElement(), this.createDefaultPricePerUnitElement());
        wrapper.append(innerWrapper, this.createButtonContainer());
      } else {
        innerWrapper.append(
          this.createPerBoxPriceElement()
          // this.createDefaultPricePerUnitElement()
        );
        wrapper.append(innerWrapper, this.createButtonContainer());
      }
    }

    return wrapper;
  }

  createPriceElement() {
    const price = document.createElement("div");
    price.classList.add("price");
    price.classList.add("price-per-capsule");

    if (this.uiType !== "non-variety" && this.currentTemplate === "product") {
      // price.classList.add("price-font-normal");
    }

    const amount = parseFloat(this.price.amount / this.numCapsulesPerBox);
    const formattedPrice = (() => {
      switch (this.price.currency_code) {
        case "USD":
        case "CAD":
        case "AUD":
          return `$${amount.toFixed(2)}`;
        case "GBP":
          return `£${amount.toFixed(2)}`;
        case "EUR":
          return `€${amount.toFixed(2)}`;
        default:
          return `${amount.toFixed(2)} ${this.price.currency_code}`;
      }
    })();

    price.innerHTML = `<span>${formattedPrice} ${this.currentTemplate === "product"
      ? window.cartStrings.perCapsule
      : ""
      }</span>`;
    return price;
  }

  createPerBoxPriceElement() {
    const price = document.createElement("div");
    price.classList.add("price");
    price.classList.add("price-per-box");

    const amount = parseFloat(this.price.amount);
    const formattedPrice = (() => {
      switch (this.price.currency_code) {
        case "USD":
        case "CAD":
        case "AUD":
          return `$${amount.toFixed(2)}`;
        case "GBP":
          return `£${amount.toFixed(2)}`;
        case "EUR":
          return `€${amount.toFixed(2)}`;
        default:
          return `${amount.toFixed(2)} ${this.price.currency_code}`;
      }
    })();

    price.innerHTML = `<span>${formattedPrice} / box of ${this.numCapsulesPerBox}</span>`;
    return price;
  }

  createButtonContainer() {
    const buttonContainer = document.createElement("div");
    buttonContainer.classList.add("add-to-cart");
    if (this.currentTemplate === "product") {
      buttonContainer.classList.add("add-to-cart-pdp");
    }
    buttonContainer.dataset.productId = this.productId;
    buttonContainer.dataset.variantId = this.variantId;
    buttonContainer.dataset.buttonSize = "small";
    buttonContainer.dataset.initialized = "true";
    buttonContainer.innerHTML = `
      <div class="add-to-cart-btn__container">
        <div id="add-to-cart-btn__button-${this.variantId}">
          <button
            class="add-to-cart-btn add-to-cart-btnSmall add-to-cart-btnSmall--active ${this.currentTemplate === "product" ? "add-to-cart-btn-pdp" : ""
      }"
            data-focus-id="add-to-cart-btn__button-${this.variantId}"
            type="button"
          >
            <div aria-hidden="true" class="add-to-cart-btnSmall__quantity">${this.currentTemplate === "product" ? "ADD TO CART" : "+"
      }</div>
          </button>
          ${this.createQuantitySelector()}
        </div>
      </div>
    `;
    return buttonContainer;
  }

  createQuantitySelector() {
    let predefinedQuantityList = [];

    if ((this.productId === "8035822534855" || this.productId === "8773255692487" || this.productId === "7519374901447")) {
      predefinedQuantityList = [0, 1, 2, 3, 4];
    } else {
      predefinedQuantityList = this.uiType === "non-variety" ? [0, 8, 16, 24, 32, 40, 48, 56] : [0, 1, 2, 3, 4, 5, 6, 7];
    }

    return `
      <div
        class="quantity-selector"
        id="quantity-selector__wrapper-${this.variantId}"
        role="dialog"
        aria-labelledby="quantity-selector__title-${this.variantId}"
        aria-describedby="quantity-selector__description-${this.variantId}"
      >
        <h3>${this.uiType === "non-variety" ? "Select Capsule Quantity" : "Select Box Quantity"
      }</h3>
        <div class="quantity-selector__container">
          <ul class="predefined-quantity-list">
            ${predefinedQuantityList
        .map(
          (quantity) => `
                <li class="predefined-quantity-list__quantity">
                  <button id="quantity-selector__predefined-${quantity}" class="predefined-quantity-list__quantity-button" data-quantity="${quantity}">
                    <span aria-hidden="true" class="notranslate">${quantity}</span>
                  </button>
                </li>
              `
        )
        .join("")}
          </ul>
          <div id="quantity-message"></div>
          <form class="quantity-selector-custom-field__container" novalidate="">
            <input
              id="quantity-selector__custom-field-${this.variantId}"
              data-focus-id="quantity-selectorCustomField__field"
              type="number"
              min="0"
              class="text-field__input quantity-selectorCustomField__input"
              placeholder="Other Amount"
            >
            <button
              id="quantity-selector__custom-ok-${this.variantId}"
              class="quantity-selector-custom-field__button-ok"
              type="submit"
            >
              UPDATE
            </button>
          </form>
        </div>
      </div>
    `;
  }

  createDefaultPricePerUnitElement() {
    const defaultPricePerUnit = document.createElement("div");
    defaultPricePerUnit.classList.add("default-price-per-unit");
    if (this.currentTemplate === "product") {
      // defaultPricePerUnit.classList.add("price-font-normal");
    }

    const amount = parseFloat(this.price.amount);
    const formattedPrice = (() => {
      switch (this.price.currency_code) {
        case "USD":
        case "CAD":
        case "AUD":
          return `$${amount.toFixed(2)}`;
        case "GBP":
          return `£${amount.toFixed(2)}`;
        case "EUR":
          return `€${amount.toFixed(2)}`;
        default:
          return `${amount.toFixed(2)} ${this.price.currency_code}`;
      }
    })();

    defaultPricePerUnit.innerHTML = `<span>${formattedPrice} / box of ${this.numCapsulesPerBox} ${this.currentTemplate === "product" ? "capsules" : ""
      }</span>`;
    return defaultPricePerUnit;
  }

  addEventListeners() {
    const addToCartButton = this.shadowRoot.querySelector(".add-to-cart-btn");
    if (addToCartButton) {
      // console.log("Adding click event listener to add-to-cart button"); // Debug
      addToCartButton.addEventListener("click", () => this.toggleQuantitySelector(this.variantId));
    } else {
      console.error("Add-to-cart button not found"); // Debug
    }

    const quantityButtons = this.shadowRoot.querySelectorAll(
      ".predefined-quantity-list__quantity-button"
    );
    if (quantityButtons.length > 0) {
      // console.log("Adding click event listeners to predefined quantity buttons"); // Debug
      quantityButtons.forEach((button) => {
        button.addEventListener("click", (event) =>
          this.handlePredefinedQuantityButtonClick(event)
        );
      });
    } else {
      console.error("Predefined quantity buttons not found"); // Debug
    }

    const customFieldContainer = this.shadowRoot.querySelector(
      ".quantity-selector-custom-field__container"
    );
    if (customFieldContainer) {
      // console.log("Adding submit event listener to custom field container"); // Debug
      customFieldContainer.addEventListener("submit", (event) => {
        event.preventDefault();
        this.updateCustomQuantity(this.variantId);
      });
    } else {
      console.error("Custom field container not found"); // Debug
    }
  }

  handlePredefinedQuantityButtonClick(event) {
    const currentBtn = event.currentTarget;
    this.shadowRoot
      .querySelectorAll(".predefined-quantity-list__quantity-button")
      .forEach((btn) => btn.classList.remove("selected"));
    currentBtn.classList.add("selected");

    const quantity = Number(currentBtn.getAttribute("data-quantity"));
    // console.log("event.currentTarget", currentBtn);
    // console.log("quantity", quantity);

    const customQuantityInput = this.shadowRoot.querySelector(
      ".text-field__input.quantity-selectorCustomField__input"
    );

    if (customQuantityInput) {
      customQuantityInput.value = quantity;
      // console.log("customQuantityInput.value", customQuantityInput.value);
    }

    if (quantity === 0) {
      this.updateQuantity(quantity, this.variantId);
    }
  }

  async fetchInitialQuantity(openCart = false) {
    if (!this.sideCart || typeof this.sideCart.getCart !== "function") {
      console.error("sideCart is not defined or getCart method is not available");
      return;
    }

    // console.log("fetchInitialQuantity", openCart);
    const cartItems = await this.sideCart.getCart();
    if (!openCart) {
      this.closeSideCart();
    }

    const cartItem = cartItems.items.find((item) => item.variant_id.toString() === this.variantId);
    const initialQuantity = cartItem ? cartItem.quantity : 0;
    // console.log("initialQuantity", initialQuantity);
    let quantity = this.uiType === "variety" ? initialQuantity : initialQuantity * 8;
    this.setAttribute("quantity", quantity);
    this.updateQuantityDisplayForVariant(this.variantId, quantity);
  }

  updateQuantityDisplayForVariant(variantId, quantity) {
    // console.log(
    //   "updateQuantityDisplayForVariant called... variantId: ",
    //   variantId,
    //   "quantity: ",
    //   quantity
    // );
    const quantityDisplay = this.shadowRoot.querySelector(
      `#add-to-cart-btn__button-${variantId} .add-to-cart-btnSmall__quantity`
    );

    if (quantityDisplay) {
      this.updateQuantityDisplay(quantityDisplay, quantity);
    }

    const allPredefinedButtons = this.shadowRoot.querySelectorAll(
      ".predefined-quantity-list__quantity-button"
    );
    allPredefinedButtons.forEach((button) => button.classList.remove("selected"));

    const predefinedButton = this.shadowRoot.querySelector(
      `.predefined-quantity-list__quantity-button[data-quantity="${quantity}"]`
    );

    if (predefinedButton) {
      predefinedButton.classList.add("selected");
    }
  }

  toggleQuantitySelector(variantId) {
    // console.log("toggleQuantitySelector called"); // Debug
    const quantitySelector = this.shadowRoot.getElementById(
      `quantity-selector__wrapper-${variantId}`
    );
    const quantitySelectorTitle = this.shadowRoot.querySelector(".quantity-selector h3");
    const quantityBtnList = this.shadowRoot.querySelector(".predefined-quantity-list");
    if (quantitySelector) {
      // console.log("Toggling visibility of quantity selector"); // Debug
      quantitySelectorTitle.style.display = "block";
      quantityBtnList.style.display = "grid";
      quantitySelector.style.display =
        quantitySelector.style.display === "block" ? "none" : "block";
    } else {
      console.error("Quantity selector not found"); // Debug
    }
  }

  async updateQuantity(quantity, variantId) {
    let formattedQuantity =
      this.uiType === "variety" ? quantity : quantity / this.numCapsulesPerBox;
    const quantityDisplay = this.shadowRoot.querySelector(
      `#add-to-cart-btn__button-${variantId} .add-to-cart-btnSmall__quantity`
    );

    if (quantityDisplay) {
      if (this.currentTemplate !== "product") {
        this.updateQuantityDisplay(quantityDisplay, quantity);
      }
      this.toggleQuantitySelector(variantId);
      this.setAttribute("quantity", quantity);
    }

    if (this.sideCart) {
      const cartItems = await this.sideCart.getCart();
      this.closeSideCart();

      const alreadyAdded = cartItems?.items?.some((item) => item.variant_id.toString() === variantId);

      if (alreadyAdded) {
        await this.updateCartItem(variantId, formattedQuantity);
      } else {
        await this.addOrUpdateCartItem(variantId, formattedQuantity);
      }
    }
  }

  updateQuantityDisplay(quantityDisplay, quantity) {
    const displayQuantity = Number(quantity);
    quantityDisplay.textContent = displayQuantity === 0 ? "+" : displayQuantity;
  }

  closeSideCart() {
    if (this.sideCart) {
      this.sideCart.classList.remove("cart--open");
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }

  async updateCartItem(variantId, quantity) {
    if (!this.sideCart) return;

    const cart = await this.sideCart.getCart();
    const index = cart.items.findIndex(item => String(item.variant_id ?? item.id) === String(variantId));
    
    if (index === -1) {
      console.warn('Variant not found in cart:', variantId, cart.items);
      return;
    }
    
    const lineIndex = index + 1;
    await this.sideCart.updateCart(lineIndex, quantity);
    this.openSideCart();
  }

  async addOrUpdateCartItem(variantId, quantity) {
    if (quantity === 0) {
      return;
    }

    if (this.sideCart) {
      await this.sideCart.addToCart(variantId, quantity, undefined, {
        _showModifiedPricing: this.showModifiedPricing,
        _modifiedPricing: this.modifiedPricing,
        _numCapsulesPerBox: this.numCapsulesPerBox,
      });
      this.openSideCart();
    }
  }

  openSideCart() {
    if (this.sideCart) {
      this.sideCart.classList.add("cart--open");
      document.querySelector("body").classList.add("overflow-hidden");
    }
  }

  updateCustomQuantity(variantId) {
    const customQuantityInput = this.shadowRoot.getElementById(
      `quantity-selector__custom-field-${variantId}`
    );
    const quantitySelector = this.shadowRoot.querySelector(".quantity-selector");
    const quantitySelectorTitle = this.shadowRoot.querySelector(".quantity-selector h3");
    const quantityBtnList = this.shadowRoot.querySelector(".predefined-quantity-list");
    const quantityMessageDiv = this.shadowRoot.getElementById("quantity-message");

    quantitySelectorTitle.style.display = "block";
    quantityBtnList.style.display = "grid";

    let quantity = Number(customQuantityInput.value);
    // console.log("before checking...quantity", quantity);


    if (quantity % this.numCapsulesPerBox !== 0 && this.uiType === "non-variety") {
      const closestMultiple = Math.ceil(quantity / this.numCapsulesPerBox) * this.numCapsulesPerBox;
      quantityMessageDiv.innerHTML = `<p>Available in multiples of ${this.numCapsulesPerBox}</p><p><strong>Modified quantity to ${closestMultiple}</strong></p>`;
      quantity = closestMultiple;
      quantitySelectorTitle.style.display = "none";
      quantityBtnList.style.display = "none";
      customQuantityInput.value = quantity;
      customQuantityInput.focus();

      if (quantitySelector.style.bottom === "-10rem") {
        quantitySelector.style.bottom = "0";
      }
    } else {
      this.updateQuantity(quantity, variantId);

      if (customQuantityInput) {
        customQuantityInput.value = quantity;
        // console.log("customQuantityInput.value", customQuantityInput.value);
      }

      const predefinedButtons = this.shadowRoot.querySelectorAll(
        ".predefined-quantity-list__quantity-button"
      );
      let matchedButton = null;

      predefinedButtons.forEach((button) => {
        const predefinedQuantity = Number(button.getAttribute("data-quantity"));
        if (predefinedQuantity === quantity) {
          matchedButton = button;
        }
        button.classList.remove("selected");
      });

      if (matchedButton) {
        matchedButton.classList.add("selected");
      }

      quantityMessageDiv.textContent = "";
    }
  }

  handleOutsideClick(event) {
    const quantitySelectors = this.shadowRoot.querySelectorAll(".quantity-selector");
    quantitySelectors.forEach((selector) => {
      const quantityBtnList = this.shadowRoot.querySelector(".predefined-quantity-list");
      const addToCartButton = this.shadowRoot.querySelector(".add-to-cart-btn");
      const customFieldContainer = this.shadowRoot.querySelector(
        ".quantity-selector-custom-field__container"
      );

      if (this.currentTemplate === "product") {
        const stickyAtcButton = document.querySelector("sticky-atc");
        if (
          selector.style.display === "block" &&
          !selector.contains(event.target) &&
          !event.composedPath().includes(addToCartButton) &&
          !event.composedPath().includes(quantityBtnList) &&
          !event.composedPath().includes(customFieldContainer) &&
          !event.composedPath().includes(stickyAtcButton)
        ) {
          selector.style.display = "none";
          selector.style.position = "absolute";
          selector.style.bottom = "unset";
        }
      } else {
        if (
          selector.style.display === "block" &&
          !selector.contains(event.target) &&
          !event.composedPath().includes(addToCartButton) &&
          !event.composedPath().includes(quantityBtnList) &&
          !event.composedPath().includes(customFieldContainer)
        ) {
          selector.style.display = "none";
        }
      }
    });
  }

  disableAtc() {
    const atcButton = this.shadowRoot.querySelector("button.add-to-cart-btn");
    // console.log("atcButton", atcButton);
    atcButton.setAttribute("disabled", true);

    if (this.currentTemplate === "product") {
      atcButton.innerHTML = `<span class="sold-out">SOLD OUT</span>`;
    } else {
      atcButton.innerHTML = `<span class="sold-out">SOLD<br>OUT</span>`;
    }

    if (this.price.currency_code === "AUD") {
      atcButton.innerHTML = `<span class="sold-out">Coming Soon</span>`;
    }
  }

  enableAtc() {
    const atcButton = this.shadowRoot.querySelector("button.add-to-cart-btn");
    // console.log("atcButton", atcButton);
    atcButton.removeAttribute("disabled");

    if (this.currentTemplate === "product") {
      atcButton.innerHTML = `<div aria-hidden="true" class="add-to-cart-btnSmall__quantity">ADD TO CART</div>`;
    } else {
      atcButton.innerHTML = `<div aria-hidden="true" class="add-to-cart-btnSmall__quantity">+</div>`;
    }
  }

  checkAvailability() {
    const atcButton = this.shadowRoot.querySelector("button.add-to-cart-btn");

    if (this.availability === "false") {
      atcButton.setAttribute("disabled", true);

      if (this.currentTemplate === "product") {
        atcButton.innerHTML = `<span class="sold-out">SOLD OUT</span>`;
      } else {
        atcButton.innerHTML = `<span class="sold-out">SOLD<br>OUT</span>`;
      }

      if (this.price.currency_code === "AUD") {
        atcButton.innerHTML = `<span class="sold-out">Coming Soon</span>`;
      }
    }
  }

  disableProductsByMarket(productIds, region) {
    if (productIds.length === 0) return;

    const isDefaultRegion = region === "";
    const isRegionMatch = isDefaultRegion
      ? !window.location.href.includes("/en-ca/") && !window.location.href.includes("/en-gb/")
      : window.location.href.includes(`/${region}/`);

    if (!isRegionMatch) return;

    productIds.forEach((productId) => {
      // console.log("productId", productId, "region", region);
      // console.log("Implementing Bartesian Pricing UI");
      const atcBtnWrapper = this.shadowRoot.querySelector(`[data-product-id="${productId}"]`);
      // console.log("atcBtnWrapper", atcBtnWrapper);
      if (atcBtnWrapper) {
        const atcButton = atcBtnWrapper.querySelector("button.add-to-cart-btn");
        if (atcButton) {
          atcButton.setAttribute("disabled", true);
          if (this.currentTemplate === "product") {
            atcButton.innerHTML = `<span class="sold-out">SOLD OUT</span>`;
          } else {
            atcButton.innerHTML = `<span class="sold-out">SOLD<br>OUT</span>`;
          }

          if (this.price.currency_code === "AUD") {
            atcButton.innerHTML = `<span class="sold-out">Coming Soon</span>`;
          }
        }
      }
    });
  }

  showModifiedPricingPerRegion(data) {
    const regionCode = data.region_code;
    const wrapper = this.parentElement;
    const quickshopWrapper = wrapper.parentElement.querySelector(".quickshop__wrapper");
    const regionCodeSpan = wrapper.querySelector(".region-code");

    this.showModifiedPricing = true;
    wrapper.classList.add("modified-pricing-enabled");

    if (quickshopWrapper) {
      quickshopWrapper.classList.add("modified-pricing-enabled");
    }

    if (regionCodeSpan) {
      regionCodeSpan.textContent = regionCode;
    }

    this.classList.remove("hide-pricing-related-element");
  }

  async checkOutOfStock() {
    this.disableProductsByMarket(oosCanadaProductIds, "en-ca");
    this.disableProductsByMarket(oosUkProductIds, "en-gb");
    this.disableProductsByMarket(oosUsaProductIds, "");

    const storedGeoData = sessionStorage.getItem("geoDetails");
    if (storedGeoData) {
      const data = JSON.parse(storedGeoData);
      this.checkRegionCodes(data);
    }

    this.addEventListeners(); // Add event listeners after geo details are fetched
  }

  // Check if sticky ATC should be disabled based on region and country
  checkRegionCodes(data) {
    const regionCodeActions = {
      no_CA: ["AZ", "CA", "ID", "MT", "NV", "OR", "UT", "WA"],
      no_TX: ["KS", "NM", "AR", "LA", "OK", "TX", "CO", "WY"],
      no_IL: ["ND", "SD", "NE", "IL", "WI", "MN", "IA", "MO", "IN", "AK", "HI", "PR"],
      no_OH: ["WV", "OH", "MI", "KY", "VA"],
      no_PA: ["ME", "NH", "VT", "MA", "RI", "CT", "NJ", "DE", "MD", "NY", "PA", "DC"],
      no_DOTH: ["AL", "MS", "SC", "NC", "TN", "FL", "GA"],
    };

    const { country_code: country, region_code: regionCode } = data;

    if (this.oosStates && this.oosStates.length > 0 && this.oosStates[0] !== "") {
      if (country === "US") {
        for (const [key, regions] of Object.entries(regionCodeActions)) {
          if (this.oosStates.includes(key)) {
            if (regions.includes(regionCode)) {
              this.disableAtc();
              return;
            } else {
              this.enableAtc();
            }
          }
        }
        if (this.oosStates.includes("no_US")) {
          this.disableAtc();
        }
      } else if (country === "CA" && this.oosStates.includes("no_CAN")) {
        this.disableAtc();
      } else if (country === "GB" && this.oosStates.includes("no_UK")) {
        this.disableAtc();
      }
    }
  }

  // Disable ATC based on region code
  disableAtcByRegionCode(
    regionCode,
    containerSelector = `product-form[data-product-id="${this.productId}"]`
  ) {
    // Locate the specified container or default product form
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Container element '${containerSelector}' not found.`);
      return;
    }

    // Retrieve the ATC button and select elements within the specified container
    const atcButton = container.querySelector("button.custom-atc");
    const selectElement = container.querySelector("select");

    // Check if the ATC button exists, then disable it and set to "SOLD OUT"
    if (atcButton) {
      atcButton.setAttribute("disabled", true);
      atcButton.innerHTML = "SOLD OUT";
      if (this.price.currency_code === "AUD") {
        atcButton.innerHTML = `<span class="sold-out">Coming Soon</span>`;
      }
    } else {
      console.warn("ATC button not found in the container.");
    }

    // Disable the select element if it exists
    if (selectElement) {
      selectElement.setAttribute("disabled", true);
    } else {
      console.warn("Select element not found in the container.");
    }
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.boundHandleOutsideClick);
  }
}

customElements.define("bartesian-pricing-ui", BartesianPricingUI);
